import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import moment from 'moment';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { LocalizationState } from '@nimbus-library/features/localization/store/localization.state';

@Pipe({
  name: 'dateSince',
  standalone: false,
})
export class DateSinceDateFormatPipe implements PipeTransform {
  public constructor(
    private readonly translateService: TranslateService,
    private readonly store: Store,
  ) {}
  public transform(value: moment.Moment | string | Date, format: string = 'L'): string {
    const now = moment();

    const lang = this.store.selectSnapshot(LocalizationState.selectedDateFormat);

    const dayDiff = now.startOf('day').diff(moment(value).startOf('day'), 'day');
    const inputDate = moment(value);

    switch (dayDiff) {
      case 0:
        return inputDate.locale(lang).format(`[${this.translateService.instant(TranslationKeys.GeneralToday)}]`);
      case 1:
        return inputDate.locale(lang).format(`[${this.translateService.instant(TranslationKeys.GeneralYesterday)}]`);
      default:
        return inputDate.locale(lang).format(`${format}`);
    }
  }
}
